// ============================================================================
// view.equipmentAdminRecord — the Admin equipment record page (A40)
// ============================================================================
// /admin/equipment/<slug>: one page per piece of equipment, hosting the editor
// that used to open as a local modal on the /admin Equipment tab. It declares
// equipment.adminRecord.core, the same equipment list the tab reads, through
// the same listEquipmentForAdmin wrapper.
//
// This surface is NEW rather than displaced: the physical read already lives
// in src/lib/equipmentAdminApi.ts, so nothing moves to `retired` in
// render-read-sites.json and `residualLegacy` is empty. The editors' own
// reads and uploads (materials, manuals, documents) are unchanged and stay in
// their files. The receipt in
// tests/fixtures/migrated-surface-receipts/view.equipmentAdminRecord.json is
// the independent record that this declaration and its catalog resource were
// introduced together.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'view.equipmentAdminRecord',
  obligations: Object.freeze([Object.freeze({id: 'equipment.adminRecord.core', owner: 'permanent'})]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
